import { request } from "../../utils/APIUtils";

// eslint-disable-next-line import/prefer-default-export
export function getApiVersion() {
	return request({
		path: `/health/version`,
		method: 'GET'
	});
}